import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

export function Card({
  children,
  className,
  as: Element = "section",
}: {
  children: ReactNode;
  className?: string;
  as?: "section" | "div" | "article";
}) {
  return (
    <Element
      className={cn(
        "bg-card border border-border rounded-container shadow-card overflow-hidden",
        className,
      )}
    >
      {children}
    </Element>
  );
}

export function CardHeader({
  title,
  description,
  action,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <header className="flex items-start justify-between gap-4 px-5 pt-5 pb-3">
      <div className="min-w-0">
        <h2 className="type-h4 text-ink">{title}</h2>
        {description ? <p className="type-support text-ink-secondary mt-1">{description}</p> : null}
      </div>
      {action}
    </header>
  );
}

export function CardBody({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn("px-5 pb-5", className)}>{children}</div>;
}

export function CardFooter({ children }: { children: ReactNode }) {
  return (
    <footer className="border-t border-border bg-surface px-5 py-3 type-support text-ink-secondary">
      {children}
    </footer>
  );
}
